var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestDevMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "code_black_48dp_1_",
    "data-name": "code_black_48dp (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M0,0H26V26H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M9.356,15.9,5.049,12,9.356,8.1a.92.92,0,0,0,0-1.4,1.168,1.168,0,0,0-1.546,0L2.741,11.29a.931.931,0,0,0,0,1.41L7.81,17.3a1.168,1.168,0,0,0,1.546,0,.92.92,0,0,0,0-1.4Zm7.289,0L20.951,12,16.644,8.1a.92.92,0,0,1,0-1.4,1.168,1.168,0,0,1,1.546,0l5.069,4.59a.931.931,0,0,1,0,1.41L18.19,17.3a1.168,1.168,0,0,1-1.546,0,.92.92,0,0,1,0-1.4Z",
    transform: "translate(0 1)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestDevMenu);
export default __webpack_public_path__ + "static/media/test_dev_menu.0f7c9c6afae3a6692ff8b8d449b63cc6.svg";
export { ForwardRef as ReactComponent };